export const CREATE_WORKSPACE_WITH_OWNER = `
  mutation CreateWorkspaceWithOwner($input: CreateWorkspaceWithOwnerInput!) {
    workspace {
      createWorkspace(input: $input) {
        ownerId
        workspaceId
      }
    }
  }
`;